import { defineComponent as _defineComponent } from 'vue'
import { useReceiptNumberCopy } from '../../../composables/useReceiptNumberCopy';
import IconButton from '~/src_common/components/parts/button/IconButton.vue';
import { SHIMMER_BAR_CLASS as bar } from '~/src_common/constants/Skeleton';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompleteReceiptTable',
  props: {
  password: { type: String, default: '' },
  email: { type: String, default: '' },
  statusText: { type: String, default: '' },
  loading: { type: Boolean, default: false },
  showStatus: { type: Boolean, default: true },
},
  setup(__props) {

const props = __props;



const { copied, copy } = useReceiptNumberCopy();

// isDesktop はグローバル mixin（src/main.js=true, src_sp/main.js=false）を
// テンプレートで直接参照する（CompleteStepper.vue と同様のパターン）。
const LABEL_CLASS_PC = 'text-base leading-5 px-4';
const LABEL_CLASS_SP = 'text-sm leading-4 px-3';
const VALUE_PX_PC = 'px-4';
const VALUE_PX_SP = 'px-3';

const handleCopyReceiptNumber = (): Promise<void> => copy(props.password);

return { __sfc: true,props, copied, copy, LABEL_CLASS_PC, LABEL_CLASS_SP, VALUE_PX_PC, VALUE_PX_SP, handleCopyReceiptNumber, IconButton, bar }
}

})